import React from "react";
import {useTranslation} from "react-i18next";
//local
import cn from "classnames";
import {Collapse} from "antd";
import {IconChevronDown, IconChevronDownMini} from "components/icons";
// import {color} from "constants/color.consts";

const {Panel} = Collapse;

const ExpandIcon = ({small, isActive}) => {
  const style = {transform: isActive ? "" : "rotate(270deg)"};

  return small ? (
    <IconChevronDownMini addClass="mr-1" style={style} />
  ) : (
    <IconChevronDown color="currentColor" addClass="mr-2" style={style} />
  );
};

const CollapseHeader = ({title, titleSuffixContent, noTranslate}) => {
  const {t} = useTranslation();
  return (
    <span className="custom-collapse__header">
      {titleSuffixContent}
      {noTranslate ? title : t(title)}
    </span>
  );
};

const CustomCollapse = ({
  title,
  titleSuffixContent,
  small,
  bold,
  uppercase,
  noTranslate,
  addClass,
  isActive,
  onChange,
  ...props
}) => (
  <Collapse
    ghost
    expandIcon={() => <ExpandIcon small={small} isActive={isActive} />}
    className={cn("custom-collapse", {
      [addClass]: !!addClass,
      __small: !!small,
      __bold: !!bold,
      __uppercase: !!uppercase,
    })}
    onChange={onChange}
    {...props}
  >
    <Panel
      header={
        <CollapseHeader
          title={title}
          titleSuffixContent={titleSuffixContent}
          noTranslate={noTranslate}
        />
      }
      isActive={isActive}
    />
  </Collapse>
);

export default CustomCollapse;
